import React from 'react'
import {
  EnrollPermissions,
  Permission,
  PermissionsStore,
  SquarePermissions,
} from '../shared-state/PermissionsStore'

export default function ValidateAccess({
  accessKey,
  children,
  checkForMasterSlave = false,
}: {
  accessKey: Permission | SquarePermissions | EnrollPermissions
  children: React.ReactNode
  checkForMasterSlave?: boolean
}) {
  const { permissions, institutionType } = PermissionsStore.useState((s) => s)
  const hasAccess = checkHasAccess(
    checkForMasterSlave,
    accessKey,
    institutionType,
    permissions,
  )

  if (hasAccess) {
    return <>{children}</>
  }
  return null
}

const checkHasAccess = (
  checkForMasterSlave,
  accessKey,
  institutionType,
  permissions,
) => {
  if (checkForMasterSlave) {
    return permissions[accessKey] && institutionType == 'MASTER_CHILD'
      ? true
      : false
  } else {
    return accessKey ? permissions[accessKey] : true
  }
}
